import React from 'react';
import { Upload, message, Button } from 'antd';
import ArrowUpIcon from "../../../assets/images/icons/arrow_up.svg";
import { CloseRounded } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { toggleTour } from '../../../reducers/tourSlice';

const { Dragger } = Upload;

const UploadMedia = ({ handleFileSelect, fileList,handelClick, disabled }) => {
    const dispatch = useDispatch();

    const beforeUpload = (file) => {
        // Define the allowed MIME type for PDF files
        const allowedMimeType = 'application/pdf';

        // Check if the file's MIME type matches PDF
        if (file.type === allowedMimeType) {

            // Create a FileReader to read the file's content
            const reader = new FileReader();

            reader.onloadend = () => {
                const buffer = reader.result;
                const uint8Array = new Uint8Array(buffer);

                // Check the first few bytes of the file to verify it's a valid PDF
                const pdfHeader = "%PDF";
                const fileHeader = String.fromCharCode.apply(null, uint8Array.slice(0, 4));

                if (fileHeader !== pdfHeader) {
                    message.error('Invalid PDF file format');
                    handleFileSelect([]);
                    return Upload.LIST_IGNORE;
                }

                // Check if the file size exceeds 100MB
                if ((file.size / 1024 / 1024) > 100) {
                    message.error('File must be smaller than 100MB!');
                    return Upload.LIST_IGNORE;
                }

                // Check for special characters in file name (allowed characters: letters, numbers, dashes, and ampersands)
                const validFilenameRegex = /^[a-zA-Z0-9\-&_ ]+\.pdf$/;
                if (!validFilenameRegex.test(file.name)) {
                    message.error("File name contains invalid characters.");
                    handleFileSelect([]);
                    return Upload.LIST_IGNORE;
                }

                // Check for duplicate files by name
                const isDuplicate = fileList.some(existingFile => existingFile.name === file.name);
                if (isDuplicate) {
                    handleFileSelect([]); // Reset the file selection
                    return Upload.LIST_IGNORE;
                }

                // If all checks pass, allow the upload
                return true;
            };

            reader.readAsArrayBuffer(file); // Read the file as an array buffer to check its content
        } else {
            // If MIME type is not PDF, show error
            message.error('Invalid File format. File should be in PDF format');
            return Upload.LIST_IGNORE;
        }
    };

    const handleFileChange = (file) => {
        const data = file.fileList.map(item => item.originFileObj ? item.originFileObj : item)
        handleFileSelect(data);
    };

    const customRequest = ({ file, onSuccess }) => {
        if (file && file.name) {
            onSuccess("ok");
        }
    }

    const onRemove = () => {
        handleFileSelect([]);
    }

    const handleClickOnDragger = () => {
        dispatch(toggleTour({ show: false }));
    }

    return (
        <Dragger className='pcvc-upload'
            fileList={fileList}
            multiple={false}
            beforeUpload={beforeUpload}
            onChange={handleFileChange}
            customRequest={customRequest}
            showUploadList={false}
            maxCount={1}
            onClick={handleClickOnDragger}
            disabled={fileList.length > 0}
        >
            <div className='upload-container'>
                {
                    fileList.length === 0 ?
                        <div className='upload-action'>
                            <div className='title'>Drag and drop here or</div>
                            <button className="btn-outlined">
                                <div className='btn-outlined-content'>
                                    <div className='text'>Upload documents </div>
                                    <img width={29} src={ArrowUpIcon} alt="" />
                                </div>
                            </button>
                        </div>
                        :
                        <div className="upload-action" style={{ zIndex: 9999 }} onClick={() => { return; }}>
                            <div className="selectedList">
                                <div className="name">{fileList[0].name}</div>
                                <CloseRounded className="remove" onClick={onRemove} />
                            </div>
                        </div>
                }

            </div>
            <div className="actions">
                <Button type="primary" onClick={handelClick} disabled={disabled}>
                    Submit
            </Button>
            </div>
        </Dragger>

    );
};

export default UploadMedia;
